import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

const BlestFiltersModal = ({
  show,
  handleClose,
  dateFrom,
  dateTo,
  filterTagType,
  filterClient,
  allTagTypes,
  allClients,
  isBrandAdmin,
  onApply,
  onClear,
}) => {
  const [localFrom, setLocalFrom] = useState(dateFrom);
  const [localTo, setLocalTo] = useState(dateTo);
  const [localTagType, setLocalTagType] = useState(filterTagType);
  const [localClient, setLocalClient] = useState(filterClient);

  useEffect(() => {
    if (show) {
      setLocalFrom(dateFrom);
      setLocalTo(dateTo);
      setLocalTagType(filterTagType);
      setLocalClient(filterClient);
    }
  }, [show, dateFrom, dateTo, filterTagType, filterClient]);

  const handleApply = () => {
    onApply({ dateFrom: localFrom, dateTo: localTo, filterTagType: localTagType, filterClient: localClient });
    handleClose();
  };

  const handleClear = () => {
    setLocalFrom("");
    setLocalTo("");
    setLocalTagType("");
    setLocalClient("");
    onClear();
    handleClose();
  };

  const hasLocal = localFrom || localTo || localTagType || localClient;

  return (
    <>
      <style>{`
        .blest-filters-modal .modal-content {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.12);
        }
        .blest-filters-modal .modal-header {
          background: #fff;
          border-bottom: 1px solid #f3f4f6;
          border-radius: 18px 18px 0 0;
          padding: 20px 24px 16px;
        }
        .blest-filters-modal .modal-body {
          background: #fff;
          padding: 20px 24px;
        }
        .blest-filters-modal .modal-footer {
          background: #f9fafb;
          border-top: 1px solid #f3f4f6;
          border-radius: 0 0 18px 18px;
          padding: 16px 24px;
        }
        .filter-label {
          font-size: 12px;
          font-weight: 700;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 6px;
          display: block;
        }
        .filter-input {
          width: 100%;
          border: 1.5px solid #e5e7eb;
          border-radius: 10px;
          padding: 9px 12px;
          font-size: 14px;
          color: #111827;
          background: #fff;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
          appearance: none;
        }
        .filter-input:focus {
          border-color: #ff5100;
          box-shadow: 0 0 0 3px rgba(255,81,0,0.1);
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="blest-filters-modal"
        style={{ backdropFilter: "blur(3px)" }}
      >
        <Modal.Header closeButton>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 34, height: 34, borderRadius: 9,
              background: "rgba(255,81,0,0.08)", border: "1.5px solid rgba(255,81,0,0.2)",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <i className="fas fa-sliders" style={{ color: "#ff5100", fontSize: 13 }} />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: "#111827" }}>Filter Statement</div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>
                Narrow down the results shown
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label className="filter-label">Date From</label>
              <input
                type="date"
                className="filter-input"
                value={localFrom}
                onChange={(e) => setLocalFrom(e.target.value)}
              />
            </div>
            <div>
              <label className="filter-label">Date To</label>
              <input
                type="date"
                className="filter-input"
                value={localTo}
                onChange={(e) => setLocalTo(e.target.value)}
              />
            </div>
            <div>
              <label className="filter-label">Tag Type</label>
              <select
                className="filter-input"
                value={localTagType}
                onChange={(e) => setLocalTagType(e.target.value)}
              >
                <option value="">All types</option>
                {allTagTypes.map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            {!isBrandAdmin && (
              <div>
                <label className="filter-label">Client</label>
                <select
                  className="filter-input"
                  value={localClient}
                  onChange={(e) => setLocalClient(e.target.value)}
                >
                  <option value="">All clients</option>
                  {allClients.map((c) => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div style={{ display: "flex", gap: 10, width: "100%" }}>
            <button
              type="button"
              onClick={handleClear}
              disabled={!hasLocal}
              style={{
                flex: 1, padding: "11px 0", borderRadius: 10,
                border: "1.5px solid #e5e7eb", background: "#fff",
                color: hasLocal ? "#dc2626" : "#9ca3af",
                fontWeight: 700, fontSize: 14, cursor: hasLocal ? "pointer" : "not-allowed",
              }}
            >
              <i className="fas fa-times" style={{ marginRight: 7 }} />
              Clear All
            </button>
            <button
              type="button"
              onClick={handleApply}
              style={{
                flex: 2, padding: "11px 0", borderRadius: 10, border: "none",
                background: "linear-gradient(135deg, #c13d00 0%, #ff5100 100%)",
                color: "#fff", fontWeight: 700, fontSize: 14,
                cursor: "pointer", display: "flex", alignItems: "center",
                justifyContent: "center", gap: 9,
              }}
            >
              Apply Filters
              <i className="fas fa-arrow-right" style={{ fontSize: 13 }} />
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BlestFiltersModal;
